/// <reference path="../../../aspnetcore-react.js" />
import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, Col, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Form from 'react-bootstrap/Form';

const Modulos = {
    moduloID: 0,
    descripcion: ""
}
const SubModulo = {
    subModuloID: 0,
    moduloID: 0,
    descripcion: ""
}
const AsignacionModulo = {
    asignacionID: 0,
    usuarioID: 1,
    subModuloID: 0,
    visualiza: false,
    modifica: false,
    elimina: false,
    imprime: false,
    aprueba: false

}

let D_usuarioID;

const AsignacionModulosLinea = ({ data }) => {
  

    const [t_modulo, sett_modulo] = useState(Modulos);
    const [t_SubModulo, sett_SubModulo] = useState(SubModulo);
    const [t_AsignacionModulo, sett_AsignacionModulo] = useState(AsignacionModulo);
    const [Listado, SetListado] = useState([]);
    const [L_Modulos, SetL_Modulos] = useState([]);
    const [L_SubModulos, SetL_SubModulos] = useState([]);
    const [ListadoPre, SetListadoPre] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);

    t_AsignacionModulo.usuarioID = data.usuarioID;
    D_usuarioID = data;
    const handleChangeModulo = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        let value;
        if (e.target.value == 'on' || e.target.value == 'off') {
            value = e.target.checked;
        } else {
            value = e.target.value;
        }


        sett_AsignacionModulo({
            ...t_AsignacionModulo,
            [e.target.name]: value
        })
    }


    const GetModulos = async () => {
        let response = await fetch(Api + "Administracion/GetModulos");
        if (response.ok) {
            let data = await response.json()
            SetL_Modulos(data)

        }
    }
    const GetAsignacionModulo = async () => {
        let response = await fetch(Api + "Administracion/GetAsignacionModulo/" + D_usuarioID.usuarioID);
        if (response.ok) {
            let data = await response.json()
            let data1 = data.filter(x => x.moduloID == D_usuarioID.moduloID).map(x => x)
            SetListado(data1)
            setPendiente();

        }
    }
    const GetSubModulos = async (x) => {
        let response = await fetch(Api + "Administracion/GetSubModulos");
        if (response.ok) {
            let data = await response.json()
            SetL_SubModulos(data)
        }
    }



    useEffect(() => {
        GetModulos();
        GetSubModulos();
        GetAsignacionModulo()
    }, [])


    //const mostrarMensaje = () => {
    //    Swal.fire({
    //        title: 'ERROR',
    //        text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
    //        icon: 'warning',
    //        showCancelButton: true,
    //        confirmButtonColor: '#3085d6',
    //        cancelButtonColor: '#d33',
    //        //confirmButtonText: 'Si, continuar',
    //        cancelButtonText: 'volver'
    //    }).then((result) => {
    //        //alert(result.value)
    //        if (result.value) {
    //        }
    //    })

    //}


    const guardarCambiosModulo = async () => {
        let response;
        if (t_AsignacionModulo.asignacionID == 0) {
            response = await fetch(Api + "Administracion/GuardarAsignacionModulo", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(t_AsignacionModulo)
            })
            setVerModal(!verModal);
        } else {
            response = await fetch(Api + "Administracion/EditarAsignacionModulo", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(t_AsignacionModulo)
            })
        }

        if (response.ok) {
            GetAsignacionModulo()
            setVerModal(false)
        } else {
            alert("error al guardar")
        }

    }



    const eliminarDatosModulo = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Administracion/EliminarAsignacionModulo/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            GetAsignacionModulo();
                            Swal.fire(
                                'Eliminado!',
                                'Fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModalModulo = (data) => {
        sett_AsignacionModulo(data);
        setVerModal(!verModal);
    }

    const cerrarModalModulo = () => {
        sett_AsignacionModulo(AsignacionModulo)
        setVerModal(false)

    }
 
    const columns = [
        {
            name: 'ID',
            selector: row => row.asignacionID,
            sortable: true,
        },
        {
            name: 'Modulo ',
            selector: row => (L_Modulos.filter(x => x.moduloID == row.moduloID).map(d => d.descripcion)),
            sortable: true,
        }, {
            name: 'SubModulo ',
            selector: row => (L_SubModulos.filter(x => x.submoduloID == row.subModuloID).map(d => d.descripcion)),
            sortable: true,
        },
        {
            name: 'Visualiza',
            selector: row => (<Form>  <Form.Check
                type="switch"
                checked={row.visualiza}
            /></Form>),
            sortable: true,
        },
        {
            name: 'Modifica',
            selector: row => (<Form>  <Form.Check
                type="switch"
                checked={row.modifica}
            /></Form>),
            sortable: true,
        },
        {
            name: 'Elimina',
            selector: row => (<Form>  <Form.Check
                type="switch"
                checked={row.elimina}
            /></Form>),
            sortable: true,
        },
        {
            name: 'Imprime',
            selector: row => (<Form>  <Form.Check
                type="switch"
                checked={row.imprime}
            /></Form>),
            sortable: true,
        },
        {
            name: 'Aprueba',
            selector: row => (<Form>  <Form.Check
                type="switch"
                checked={row.aprueba}
            /></Form>),
            sortable: true,
        },

        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModalModulo(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                    <Button color="danger" size="sm" className="mr-2"
                        onClick={() => eliminarDatosModulo(row.asignacionID)}
                    >
                        <i className="fas fa-trash-alt"></i>
                    </Button>



                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>

                </CardHeader>
              
                    <DataTable
                        columns={columns}
                    data={Listado}
                         pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />

                  
              
            </Card>

           

        </>
    )

}
export default AsignacionModulosLinea;